import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_file_upload = _resolveComponent("file-upload")!
  const _component_loader = _resolveComponent("loader")!
  const _component_table_action_header = _resolveComponent("table-action-header")!
  const _component_custom_table = _resolveComponent("custom-table")!
  const _component_pagination = _resolveComponent("pagination")!
  const _component_main_section = _resolveComponent("main-section")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isCreateModalOpened)
      ? (_openBlock(), _createBlock(_component_file_upload, {
          key: 0,
          "is-create-modal-opened": _ctx.isCreateModalOpened,
          onRefreshData: _cache[0] || (_cache[0] = ($event: any) => (_ctx.getStoredFiles())),
          onToggleModal: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isCreateModalOpened = false))
        }, null, 8, ["is-create-modal-opened"]))
      : _createCommentVNode("", true),
    _createVNode(_component_main_section, null, {
      default: _withCtx(() => [
        (_ctx.isLoading)
          ? (_openBlock(), _createBlock(_component_loader, { key: 0 }))
          : (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createVNode(_component_table_action_header, {
                "button-text": _ctx.$t('General.Upload'),
                icon: ['fas', 'add'],
                "permission-id": _ctx.permissions.CreateFirmwareUpdate,
                title: _ctx.$t('FirmwareUpdate.Title'),
                description: " ",
                onExecuteMethod: _ctx.toggleCreateModal
              }, null, 8, ["button-text", "permission-id", "title", "onExecuteMethod"]),
              _createVNode(_component_custom_table, {
                options: _ctx.options,
                "is-data-source-loading": _ctx.isDataSourceLoading,
                "table-data": _ctx.paginatedStoredFiles.items,
                "table-headers": _ctx.tableHeaders,
                onSelectedRows: _ctx.getSelectedRow,
                onForceRefresh: _cache[2] || (_cache[2] = ($event: any) => (_ctx.getStoredFiles()))
              }, null, 8, ["options", "is-data-source-loading", "table-data", "table-headers", "onSelectedRows"]),
              _createVNode(_component_pagination, {
                "pagination-data": _ctx.paginatedStoredFiles,
                onPageChange: _ctx.handlePageChange,
                onPageSizeChange: _ctx.handlePageSizeChange
              }, null, 8, ["pagination-data", "onPageChange", "onPageSizeChange"])
            ]))
      ]),
      _: 1
    })
  ], 64))
}